import { useAuthorizedApiCall } from '@/api/use-authorized-api-call';
import { QUERY_KEYS_ACCOUNT } from '@/features/account/api/query/index';
import type { FavoritesResponse } from '@/features/account/api/types';
import { getPaginationLimit } from '@/utils/get-pagination-limit';
import { useIsCustomer } from '@/utils/is-customer';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

export const useWishList = (limit?: number) => {
  const defaultLimit = getPaginationLimit(limit);
  const searchLimit = defaultLimit ? `?limit=${defaultLimit}` : '';
  const isCustomer = useIsCustomer();

  const queryFn = useAuthorizedApiCall<FavoritesResponse>((api) =>
    api.get(`customers/favourites${searchLimit}`),
  );

  return useQuery({
    queryKey: [QUERY_KEYS_ACCOUNT.WISHLIST, defaultLimit],
    queryFn,
    retry: false,
    placeholderData: keepPreviousData,
    enabled: isCustomer,
    throwOnError: false,
  });
};
